import { useEffect, useState } from "react";
import { useAuth } from "react-oidc-context";

export interface LoginRedirectProps {
    redirectPath?: string
}

export function LoginRedirect({ redirectPath = process.env.REACT_APP_OIDC_REDIRECT_URI as string }: LoginRedirectProps) {
    const auth = useAuth()
    const [redirecting, setRedirecting] = useState<boolean>(false)
    useEffect(() => {
        if (auth && !redirecting) {
            auth.signinRedirect({
                redirect_uri: redirectPath
            })
        }
    }, [auth, redirecting, redirectPath])
    useEffect(() => {
        setRedirecting(true)
        return () => setRedirecting(false)
    }, [])
    return null
}